<main id="content" class="bg-white">
    <div class="bg-paws-header border-bottom content-header">
        <h1 class="d-inline-flex pe-3 mb-0">My Classes </h1>
    </div>
    <div class="bg-white content-body container">

    @if ( classScheduleState != 'none' ) {
        <table class="table table-borderless">
            <tbody>
                @for( class of classes; track $index ) {
                    <tr>
                        <td>
                            <div class="">{{ class.courseCode }} {{ class.courseNumber }}</div>
                            <div class="fw-bold">{{ class.courseName }}</div>
                            <div class="text-muted">{{ class.courseCRN }}.{{ class.courseTerm }}</div>
                            @if ( class.gradesProcessed == 'Y' ) {
                                <div><a [routerLink]="['/finalgrades']">Grade Available</a></div>
                            }
                        </td>
                        <td>
                            <div><strong>{{ class.instructionalMethods }}</strong></div>
                            @if ( class.courseLocation.roomNumber != 'NO_ROOM' ) {
                                <div>{{ class.courseCampus.title }}</div>
                                <div><a [routerLink]="['/campusmap']">{{ class.courseLocation.buildingName }} {{ class.courseLocation.roomNumber }}</a></div>
                            }
                            <div>{{ class.instructionalDeliveryMethod }}</div>
                        </td>
                        <td>
                            <strong>Class Schedule</strong>
                            @if ( class.courseSchedule.length > 0 ) {
                                @for ( time of class.courseSchedule; track $index ) {
                                    <div class="border-bottom">
                                    @if ( time.startDate == time.endDate ) {
                                        <div>{{ time.startDate | formatDate:'PPP' }} &#64; {{ time.startTime | formatTime }}-{{ time.endTime | formatTime }}</div>
                                    } @else {
                                        <div>{{ time.startDate | formatDate:'PPP' }} - {{ time.endDate | formatDate:'PPP' }}</div>
                                        @if ( time.daysOfWeek.length > 0 ) {
                                            <div class="weeklySchedule row ms-0">
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'sunday')">S</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'monday')">M</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'tuesday')">T</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'wednesday')">W</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'thursday')">T</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'friday')">F</div>
                                                <div class="col" [class.active]="eventHasDayOfWeek(time.daysOfWeek,'saturday')">S</div>
                                            </div>
                                        }
                                        @if ( time.startTime != '00:00:00' ) {
                                            <div class="">{{ time.startTime | formatTime }} - {{ time.endTime | formatTime }}</div>
                                        }
                                    }
                                    </div>
                                }
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>

        <div class="list-group border-bottom pb-2 d-none" id="class_list">
            <div class="list-group-item px-3 pb-1">
                @if ( classScheduleState == 'loading' ) {
                    <div class="text-center mt-2 float-end">

                    </div>
                } @else if ( classScheduleState == 'error' || classes.length == 0 ) {
                    <div class="">No classes were found for this term.</div>
                }
            </div>
            @for( class of classes; track $index ) {
                <div class="list-group-item px-3 py-0" data-cy="eventItem_container">
                    <div class="px-0 py-2">
                        @if ( class.courseDays ) {
                            <div class="time">
                                @if ( class.courseEnded ) {
                                    @if ( class.gradesProcessed == 'Y' ) {
                                        <a class="fw-bold text-warning" href="" [routerLink]="['/finalgrades']">Grade Available</a>
                                    }

                                } @else if ( !class.courseStarted ) {
                                    First Class {{ class.courseStartFormated }}
                                } @else {
                                    {{ class.courseTime }} - {{ class.courseDays }}
                                }
                            </div>
                        }
                        <div class="title">
                            {{ class.courseCode }} {{ class.courseNumber }} {{ class.courseName }}
                        </div>
                        @if ( class.courseLocation != undefined && class.courseLocation.roomNumber != 'NO_ROOM' ) {
                            <a class="text-secondary" routerLink="/campusmap">
                                {{ class.courseLocation.buildingName }} - {{ class.courseLocation.roomNumber }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>
    }
    </div>
</main>
